import { render, staticRenderFns } from "./TalentMatrices.vue?vue&type=template&id=67b4a81a&scoped=true"
import script from "./TalentMatrices.vue?vue&type=script&lang=js"
export * from "./TalentMatrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b4a81a",
  null
  
)

export default component.exports